<template>
  <div>
    <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup" v-if="addNotes" :class="{ show: addNotes }">
      <div class="cstm-modal medium fixed_medium">
        <div class="header">
          <h4>{{ type }} Note</h4>
          <button @click="closeNoteTemplateModal" class="close-modal">
            &times;
          </button>
        </div>
        <div class="modal-content p-4">
          <vs-input placeholder="Notes Title" class="w-full mb-4" :disabled="type === 'Preview'"
            v-model="createPayload.title" />

          <div>
            <h4 style="cursor: pointer;" class="mb-4" @click="add_description = !add_description">
              <a class="primary">+ Add Description</a>
            </h4>
          </div>
          <vs-textarea :disabled="type === 'Preview'" v-model="createPayload.description" v-if="add_description" />
          <editor :disabled="type === 'Preview'" ref="tinyMce" v-model="createPayload.body" :api-key="tinyMceApi"
            :init="initializeTinyMce" />

          <div class="border_btm py-4">
            <h4 class="mb-4">Linked Online Resources</h4>
            <vs-button type="border" :disabled="type === 'Preview'" v-if="!addFileModal && filesInfo.length == 0" icon="add"
              @click="addFileModal = true">Add file</vs-button>
            <div v-if="addFileModal">
              <FileUpload section_type="Notes" :multiplefile="true" @getFileIdHeader="getIdFile"
                :file_repository_id="repository_id" :filesInfo="filesInfo" @deletedIndex="deletedIndex"
                ref="fileUploadRef" />
            </div>
          </div>

          <div class="flex flex-wrap justify-between items-center border_btm py-4 mb-4">
            <div class="inline-flex items-center">
              <strong class="pr-4">Private</strong>
              <vs-switch v-model="createPayload.is_private" :disabled="type === 'Preview'" />
            </div>
            <vs-icon style="font-size: 24px;" icon-pack="feather" icon="icon-lock"
              :disabled="!createPayload.is_private" />
          </div>
          <div class="flex flex-wrap justify-between items-cente" v-if="type != 'Preview'">
            <vs-button class="block mx-auto" @click="createNoteTemplate(!createPayload.is_private)">Save</vs-button>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>
<script>

import FileUpload from '@/views/pages/v1/notes/components/Template/NotesFileComponent.vue'
import Editor from '@tinymce/tinymce-vue'
import {createNote, updateNote} from '@/api/lesson_notes.js'
import { repository } from '@/mixins/repository.js'


export default {
  components: {
    editor: Editor,
    FileUpload
  },
  props: {
    addNotes:{
      default: false
    },
    type:{
      default: 'Add'
    },
    editPayload:{
      default: ''
    }
  },
  mixins: [repository],
  data () {
    return {
      filesInfo:[],
      createPayload:{
        'schedule_id': null,
        'course_id': null,
        'title': '',
        'description': '',
        'body': '',
        'has_all_subject':true,
        'save_type':false,
        'originated_from':'LESSON_NOTE',
        'is_private':false,
        'files':[]
      },
      addFileModal:false,
      add_description:true,
      tinyMceApi: '',

      initializeTinyMce:{
        setup :(editor) => {
          editor.ui.registry.addIcon('filesIcon', '<svg class="primary_svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"/></svg>')
          editor.ui.registry.addIcon('gDriveIcon', '<svg class="font_18" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "></polyline><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "></polyline><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "></polyline></g></svg>')

          editor.ui.registry.addButton('customInsertButton', {
            icon: 'filesIcon',
            tooltip: 'Insert Image from repo',
            classes: 'myClass',

            onAction:() => {
              this.importModelRepo(editor)
            }
          })
          editor.ui.registry.addButton('gDrive', {
            // text: 'Gdrive',
            icon: 'gDriveIcon',
            tooltip: 'Insert from GDrive',
            onAction:() => { this.gDrive(editor) }
          })
        },
        height: 300,
        menubar: true,
        branding: false,
        images_upload_url: this.image_url,
        automatic_uploads: true,
        images_upload_credentials: true,
        images_upload_handler: this.images_upload_handler,
        plugins: [
          'autolink lists link image charmap print preview anchor',
          'imagetools',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
          'code lists fullscreen',
          'emoticons'
        ],
        menu: 'table',
        toolbar: 'customInsertButton gDrive insertfile image link |undo redo | formatselect | bold italic backcolor | \
        table alignleft aligncenter alignright alignjustify | \
        bullist numlist outdent indent | removeformat | help'
      }
    }
  },
  mounted () {
    this.getRepositoryId(54)
    if (this.type === 'Edit' || this.type === 'Preview') {

      this.createPayload.title = this.editPayload.title
      this.createPayload.description = this.editPayload.description
      this.createPayload.body = this.editPayload.body
      this.createPayload.has_all_subject = this.editPayload.has_all_subject
      this.createPayload.is_private = this.editPayload.is_private
      this.filesInfo = this.editPayload.file
      this.addFileModal = this.editPayload.file.length > 0

      console.log(this.editPayload)
    }
  },
  methods: {
    closeNoteTemplateModal () {
      this.$emit('closeNoteTemplateModal', true)
    },
    deletedIndex (deleteIndex) {
      this.filesInfo.splice(deleteIndex, 1)
      this.createPayload.files = null
    },
    getIdFile (obj) {
      console.log(obj)
      this.createPayload.files.push(obj)
    },
    async createNoteTemplate (save_type) {
      if (this.type === 'Add') {
        const payload = {
          ...this.createPayload,
          save_type
        }
        await createNote(localStorage.getItem('customer_id'), payload)
      } else {
        const payload = {
          ...this.createPayload,
          id : this.editPayload.id
        }
        await updateNote(localStorage.getItem('customer_id'), payload, this.editPayload.id)
      }

      this.closeNoteTemplateModal()
    },
    importModelRepo (editor) {
      this.editorComponent = editor
      this.isBrowseContent = true
    }
  }
}
</script>
